import React, {FC} from 'react'
import {useAppDispatch} from 'redux/config'
import {useSelector} from 'react-redux'
import {toastAC} from 'redux/toast/toast.duck'
import {select_toasts, select_toasts_areDisplayable} from 'redux/toast/selectors'

import {Toast, ToastContainer} from '@mdsol/onex-design'
import {ToastType} from 'redux/toast/state'

const ToastsContainer: FC = () => {
  const dispatch = useAppDispatch()

  const displayToasts = useSelector(select_toasts_areDisplayable)
  const toasts = useSelector(select_toasts)

  const handleClose = (toast: ToastType) => {
    dispatch(toastAC.toastRemoved(toast))
  }

  const ToastChildren = ({message}) => {
    return message.split('\n').map(msg => (
      <div key={msg}>{msg}</div>
    ))
  }

  return (
    <ToastContainer dataTestId='legion-toasts-container' position='bottom-start'>
      {displayToasts && toasts.map(toast => (
        <Toast
          key={`toast-${toast.id}-key`}
          autohide={true}
          header={toast.header}
          variant={toast.variant}
          delay={toast.delay}
          onClose={() => {
            handleClose(toast)
          }}
        >
          {<ToastChildren message={toast.message}/>}
        </Toast>
      ))}
    </ToastContainer>
  )
}

export default ToastsContainer
